import { JobsStore } from "../jobs.store";
import { JobsService } from "../jobs.service";
import { Job, TaskGroup } from "../job.model";
import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  ViewChild,
  OnDestroy,
  inject,
  DestroyRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { DashboardService } from "src/app/dashboard/dashboard.service";
import { DashboardStore } from "src/app/dashboard/dashboard.store";
import { TagAddComponent } from "../../../common/tags/tag-add/tag-add.component";
import { AutosizeModule } from "ngx-autosize";
import { JobContentComponent } from "../job-content/job-content.component";
import { JobsAndTasksCardComponent } from "../jobs-and-tasks-card/jobs-and-tasks-card.component";
import { NgClass, NgFor, NgIf } from "@angular/common";
import { TagComponent } from "../../../common/tags/tag.component";
import { FormsModule } from "@angular/forms";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
    selector: "ch-job-templates",
    templateUrl: "./job-templates.component.html",
    styleUrls: ["./job-templates.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        TooltipModule,
        FormsModule,
        TagAddComponent,
        TagComponent,
        NgClass,
        NgFor,
        JobsAndTasksCardComponent,
        NgIf,
        JobContentComponent,
        AutosizeModule,
    ]
})
export class JobTemplatesComponent implements OnInit, OnDestroy {
  @ViewChild("tagList") tagList: TagAddComponent;

  constructor(
    public jobsService: JobsService,
    private jobsStore: JobsStore,
    private cdr: ChangeDetectorRef,
    private modalService: BsModalService,
    private dashboardService: DashboardService,
    private dashboardStore: DashboardStore,
  ) {}

  templates: Array<Job> = [];
  filteredTemplates: Array<Job> = [];
  selectedJob: Job = null;
  activeTab = "templates";
  loading = false;
  selectedFilterTags = [];
  andOrFilter = "or";
  searchTemplateInput: string = "";

  modalRef: BsModalRef;
  aiJobDescription = "";

  readonly destroyRef = inject(DestroyRef);

  ngOnDestroy(): void {}

  ngOnInit() {
    this.loading = true;
    this.jobsService
      .getJobTemplates("templates")
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => {
        this.templates = <Array<Job>>res.jobs;
        this.filteredTemplates = this.templates;
        console.log(this.templates);
        this.switchJobsTabs("templates");
        this.loading = false;
        this.cdr.detectChanges();
      });

    this.jobsStore.notifyJobDeleted
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((sub) => {
        this.selectedJob = null;
        this.templates = this.templates.filter((j) => {
          return j.uuid !== sub;
        });
        this.switchJobsTabs(this.activeTab);
        this.cdr.detectChanges();
      });

    this.jobsService.newTemplate
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((job: Job) => {
        this.templates.push(<Job>job);

        console.log("new template", job);

        this.switchJobsTabs("templates");
        this.selectJob(job);
        this.cdr.detectChanges();
      });
  }

  selectJob(job: Job) {
    this.templates.forEach((j) => {
      j["selected"] = false;

      if (j.uuid === job.uuid) {
        j["selected"] = true;
      }
    });
    this.selectedJob = job;
    this.jobsService.setSelectedJob.next(this.selectedJob.uuid);
    this.selectedJob["selected"] = true;
    this.cdr.detectChanges();
  }

  newJobTemplate() {
    const newJob = new Job({ is_template: true });
    this.templates.push(newJob);
    this.selectJob(newJob);
    this.cdr.detectChanges();
  }

  newJobMagicTemplate(template) {
    this.modalRef = this.modalService.show(template, {
      class: "create-ai-job-modal modal-md",
      ignoreBackdropClick: true,
    });
  }

  createAIJob() {
    this.loading = true;
    // this.dashboardService.show_loading.next(true);
    this.jobsService
      .createAIJob(null, this.aiJobDescription)
      .subscribe((res) => {
        this.aiJobDescription = "";
        // this.toastr.success(res.message);
        this.templates.push(res.job);
        this.selectJob(res.job);
        this.loading = false;
        // this.dashboardService.show_loading.next(false);

        this.cdr.detectChanges();

        this.modalRef.hide();
      });
  }

  switchJobsTabs(tab) {
    this.activeTab = tab;
    this.loading = true;
    if (tab == "global") {
      this.jobsService.getJobTemplates("global").subscribe((res) => {
        const jobTemplates = res.jobs;
        this.templates = jobTemplates;
        this.filteredTemplates = this.templates;
        this.loading = false;
        this.cdr.detectChanges();
      });
    } else if (tab == "templates") {
      this.jobsService.getJobTemplates("templates").subscribe((res) => {
        const jobTemplates = res.jobs;
        this.templates = jobTemplates;
        this.filteredTemplates = this.templates;
        this.loading = false;
        this.cdr.detectChanges();
      });
    }
  }

  applyFilter() {
    if (this.searchTemplateInput || this.selectedFilterTags.length > 0) {
      this.filteredTemplates = this.templates.filter((template) => {
        const searchMatch =
          !this.searchTemplateInput ||
          template.name
            .toLowerCase()
            .includes(this.searchTemplateInput.toLowerCase());

        const filterTagsMatch =
          this.selectedFilterTags.length === 0 ||
          template.tags.some((tag) =>
            this.selectedFilterTags.some((t) => t.uuid === tag.uuid),
          );

        return searchMatch && filterTagsMatch;
      });
    } else {
      this.filteredTemplates = this.templates;
    }
  }

  addTagToFilter(tag) {
    this.selectedFilterTags.push(tag);
    this.tagList.tags = this.tagList.tags.filter((t) => t.uuid !== tag.uuid);
    this.tagList.addedTags = this.selectedFilterTags;
    this.applyFilter();
    this.tagList.dropdown.show();
  }

  removeTagFromFilter(tag) {
    this.tagList.tags.push(tag);
    this.selectedFilterTags = this.selectedFilterTags.filter(
      (t) => t.uuid !== tag.uuid,
    );
    this.tagList.addedTags = this.selectedFilterTags;
    this.applyFilter();
  }

  changeAndOrFilter(andOr) {
    this.andOrFilter = andOr;
    console.log("andOrFilter", this.andOrFilter);
  }

  clearFilter() {
    this.selectedFilterTags = [];
    this.tagList.tags = this.tagList.all_tags;
    this.applyFilter();
    this.tagList.dropdown.hide();
  }
}
